import { render, staticRenderFns } from "./UserDefault.vue?vue&type=template&id=77368a8d&scoped=true"
import script from "./UserDefault.vue?vue&type=script&lang=js"
export * from "./UserDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77368a8d",
  null
  
)

export default component.exports